import { Center, VStack, Tag, TagLeftIcon } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import type { StudentType } from './StudentDetailPage';
import { LandmarkIcon } from 'lucide-react';
import { StudentEnrolmentCard } from '@duke-hq/enrolments-ui/components/StudentEnrolmentCard';

export function StudentEnrolments({ student }: { student: StudentType }) {
  const { data: enrolments } = trpcAdmin.students.enrollmentsById.useQuery({
    user_id: student.id,
    fetchAll: true,
  });

  if (enrolments && enrolments.length > 0) {
    return (
      <VStack p={4} spacing={4}>
        {enrolments.flatMap((enrolment) => {
          if (enrolment.course == null) {
            return [];
          }
          return (
            <StudentEnrolmentCard
              key={enrolment.id}
              enrolmentId={enrolment.id}
              health={enrolment.health}
              course={enrolment.course}
              consultant={enrolment.consultant}
              extraTags={
                enrolment.provider != null ? (
                  <Tag size="sm" colorScheme="gray" variant="subtle">
                    <TagLeftIcon as={LandmarkIcon} />
                    {enrolment.provider.name}
                  </Tag>
                ) : null
              }
            />
          );
        })}
      </VStack>
    );
  }

  return (
    <Center>
      <VStack spacing={2}>
        <Trans>No enrolments available</Trans>
      </VStack>
    </Center>
  );
}
